var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [
        _vm._v(_vm._s(_vm.$t("auto.systemFeature"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("auto.ticketReceivingLimit"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.ticketReceivingLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "ticketReceivingLimit", $$v)
                },
                expression: "featureForm.ticketReceivingLimit",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("auto.readyContentsLimit"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.readyContentsLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "readyContentsLimit", $$v)
                },
                expression: "featureForm.readyContentsLimit",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("auto.departmentLimit"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.departmentLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "departmentLimit", $$v)
                },
                expression: "featureForm.departmentLimit",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("auto.roleLimit"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.roleLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "roleLimit", $$v)
                },
                expression: "featureForm.roleLimit",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("auto.maxDiskSize"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.maxDiskSize,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "maxDiskSize", $$v)
                },
                expression: "featureForm.maxDiskSize",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("auto.freeAiToken"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.freeAIToken,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "freeAIToken", $$v)
                },
                expression: "featureForm.freeAIToken",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "feature-input" },
        [
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              model: {
                value: _vm.featureForm.support,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "support", $$v)
                },
                expression: "featureForm.support",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "basic-support" } }, [
                _vm._v(_vm._s(_vm.$t("auto.basicSupport"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "7-24-support" } }, [
                _vm._v(_vm._s(_vm.$t("auto.twentyFourSevenSupport"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-item" }, [
      _c("div", { staticClass: "feature-label" }, [
        _vm._v(_vm._s(_vm.$t("auto.otherFeatures"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "feature-input" },
        [
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.softwareSupport,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "softwareSupport", $$v)
                },
                expression: "featureForm.softwareSupport",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.softwareSupport")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.dedicatedCustomerSupport,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "dedicatedCustomerSupport", $$v)
                },
                expression: "featureForm.dedicatedCustomerSupport",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.dedicatedCustomerSupport")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.supportWhatsappBusinessSetup,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "supportWhatsappBusinessSetup", $$v)
                },
                expression: "featureForm.supportWhatsappBusinessSetup",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.whatsappBusinessSetup")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.supportFacebookSetup,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "supportFacebookSetup", $$v)
                },
                expression: "featureForm.supportFacebookSetup",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.facebookSetup")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.supportInstagramSetup,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "supportInstagramSetup", $$v)
                },
                expression: "featureForm.supportInstagramSetup",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.instagramSetup")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.supportChatbotSetup,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "supportChatbotSetup", $$v)
                },
                expression: "featureForm.supportChatbotSetup",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.chatbotSetup")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.supportAISetup,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "supportAISetup", $$v)
                },
                expression: "featureForm.supportAISetup",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.aiSetup")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.supportAutomationSetup,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "supportAutomationSetup", $$v)
                },
                expression: "featureForm.supportAutomationSetup",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.automationSetup")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.supportSpecialPanelTraining,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "supportSpecialPanelTraining", $$v)
                },
                expression: "featureForm.supportSpecialPanelTraining",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.specialPanelTraining")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.supportConsultancy,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "supportConsultancy", $$v)
                },
                expression: "featureForm.supportConsultancy",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.consultancy")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.supportIntegrationSetup,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "supportIntegrationSetup", $$v)
                },
                expression: "featureForm.supportIntegrationSetup",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.integrationSetup")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.supportStrategyPlanning,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "supportStrategyPlanning", $$v)
                },
                expression: "featureForm.supportStrategyPlanning",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.strategyPlanning")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.readyContentsImage,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "readyContentsImage", $$v)
                },
                expression: "featureForm.readyContentsImage",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.readyContentImageAdd")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.chatAndNotification,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "chatAndNotification", $$v)
                },
                expression: "featureForm.chatAndNotification",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.chatAndNotification")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.chatBalloonCustomization,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "chatBalloonCustomization", $$v)
                },
                expression: "featureForm.chatBalloonCustomization",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.chatBalloonCustomization")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.removeSupsisLogo,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "removeSupsisLogo", $$v)
                },
                expression: "featureForm.removeSupsisLogo",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.removeSupsisLogo")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.databaseConnection,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "databaseConnection", $$v)
                },
                expression: "featureForm.databaseConnection",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.databaseConnection")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.singlePanelAccess,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "singlePanelAccess", $$v)
                },
                expression: "featureForm.singlePanelAccess",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.singlePanelAccess")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.ticketSystem,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "ticketSystem", $$v)
                },
                expression: "featureForm.ticketSystem",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.ticketSystem")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.visitorStartChat,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "visitorStartChat", $$v)
                },
                expression: "featureForm.visitorStartChat",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.visitorStartChat")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.chatbotEntegration,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "chatbotEntegration", $$v)
                },
                expression: "featureForm.chatbotEntegration",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.chatbotIntegration")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.teamChatEntegration,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "teamChatEntegration", $$v)
                },
                expression: "featureForm.teamChatEntegration",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.teamChatIntegration")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.whatsappEntegration,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "whatsappEntegration", $$v)
                },
                expression: "featureForm.whatsappEntegration",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.whatsappIntegration")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.instagramEntegration,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "instagramEntegration", $$v)
                },
                expression: "featureForm.instagramEntegration",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.instagramIntegration")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.messengerEntegration,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "messengerEntegration", $$v)
                },
                expression: "featureForm.messengerEntegration",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.messengerIntegration")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.telegramEntegration,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "telegramEntegration", $$v)
                },
                expression: "featureForm.telegramEntegration",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.telegramIntegration")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.mailEntegration,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "mailEntegration", $$v)
                },
                expression: "featureForm.mailEntegration",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.mailIntegration")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.smsEntegration,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "smsEntegration", $$v)
                },
                expression: "featureForm.smsEntegration",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.smsIntegration")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.webhookEntegration,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "webhookEntegration", $$v)
                },
                expression: "featureForm.webhookEntegration",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.webhookIntegration")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.calenderEntegration,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "calenderEntegration", $$v)
                },
                expression: "featureForm.calenderEntegration",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.calendarIntegration")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.calendarWebFeature,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "calendarWebFeature", $$v)
                },
                expression: "featureForm.calendarWebFeature",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.calendarWebFeature")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.taskManagementEntegration,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "taskManagementEntegration", $$v)
                },
                expression: "featureForm.taskManagementEntegration",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.taskManagement")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.dataProtect,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "dataProtect", $$v)
                },
                expression: "featureForm.dataProtect",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.dataSecurity")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.accessAllAgent,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "accessAllAgent", $$v)
                },
                expression: "featureForm.accessAllAgent",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.accessForAllAgents")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.readyContents,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "readyContents", $$v)
                },
                expression: "featureForm.readyContents",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.readyContents")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.allEntegrations,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "allEntegrations", $$v)
                },
                expression: "featureForm.allEntegrations",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.allIntegrations")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.permissionControl,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "permissionControl", $$v)
                },
                expression: "featureForm.permissionControl",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.permissionFeatures")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.autoRezervation,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "autoRezervation", $$v)
                },
                expression: "featureForm.autoRezervation",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.autoReservation")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.flexibleBilling,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "flexibleBilling", $$v)
                },
                expression: "featureForm.flexibleBilling",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.flexibleBilling")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.featureForm.accessControl,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "accessControl", $$v)
                },
                expression: "featureForm.accessControl",
              },
            },
            [_vm._v(_vm._s(_vm.$t("auto.accessControl")))]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }